import { useMsal } from '@azure/msal-react';
import { CircularProgress, Container, Grid, Link, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Accordion, AccordionSummary, Tooltip, Button } from '@material-ui/core'
import { Error, CheckCircle } from '@material-ui/icons';
import React, { ReactElement, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { globalStyles } from '../../../assets/globalStyles';
import { useStyles } from './gruppenStyles';
import { getPQStatusGruppe, selectPQStatusGruppeLoading, selectPQStatusGruppe, } from './gruppenSlice';
import { useHistory } from 'react-router';
import { setMessstellenFilter, setZeitraum } from '../pqEreignisseSlice';
import { getWithAuth } from '../../../utils/api';
import { gruppenzuordnung } from './../../../utils/apiTypes';
import { logError } from '../../../utils/utils';
import LegendeStoerung from '../../../features/legende/legendeStoerung';
import { errorHandler } from '../../../utils/errorHandling';
import CachedIcon from '@material-ui/icons/Cached';


export default function Gruppen(): ReactElement {
    const dispatch = useAppDispatch();
    const { instance } = useMsal();
    const [reload, setReload] = React.useState(false);

    useEffect(() => {
        dispatch(getPQStatusGruppe());
    }, [instance, reload]);

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    const pqStatusGruppe = useAppSelector(selectPQStatusGruppe);
    const gruppentypen = [...new Set(pqStatusGruppe.map(x => x.gruppentyp).sort((a, b) => a.localeCompare(b)))];
    const pqStatusGruppeLoading = useAppSelector(selectPQStatusGruppeLoading);

    const getIconForStateValue = (value: number) => {
        switch (value) {
            case 0:
                return (
                    <Tooltip title="Keine Störung" >
                      <CheckCircle style={{ color: "green" }} />
                    </Tooltip>)
            case 1:
                return (
                    <Tooltip title="Störung bei geplanten Ereignissen" >
                        <Error style={{ color: "green" }} />
                    </Tooltip>)
            case 2:
                return (
                    <Tooltip title="Punktereignis (kürzer 1 Sekunde" >
                      <Error style={{ color: "orange" }} />
                    </Tooltip>)
            case 3:
                return (
                    <Tooltip title="Abschnittsereignis (länger 1 Sekunde)" >
                      <Error className={classes.redSignalColor} />
                    </Tooltip>)
            default: return "";
        }
    }

    const history = useHistory();
    const linkToDetails = (gruppenId: number, zeitraum: string) => {
        history.push("/uebersicht/pqereignisse");
        getWithAuth("GRUPPENZUORDNUNG", {})
            .then((gruppenzuordnungen: Array<gruppenzuordnung>) => {
                dispatch(setMessstellenFilter(gruppenzuordnungen.filter(x => x.gruppeId == gruppenId).map(x => x.messstelle)));
                dispatch(setZeitraum(zeitraum));
            })
            .catch((error) => {
                logError(error);
                errorHandler(error, dispatch);
            });
    }

    return (
        <Container maxWidth={false} style={{ marginTop: "10px" }}>
            <Grid item container md={12}>
                <Grid item md={12} >
                    <Typography color="primary" variant="h5">
                        PQ-Ereignisse Gruppen
                    </Typography>
                </Grid>
                <Grid item md={12} >
                  <Grid item md={12} style={{ textAlignLast: "right", marginTop: "-24px", marginBottom: "16px" }}>
                    <Button color="secondary" 
                    onClick={() => setReload(!reload)}>Neu Laden<CachedIcon style={{marginLeft: "10px"}}/></Button >
                  </Grid> 
                </Grid>
                <Grid item md={12} >
                    <LegendeStoerung name={"gruppen"}/>
                </Grid>
                {pqStatusGruppeLoading ? <Grid item md={12}><CircularProgress style={{ alignSelf: "center", padding: "5px" }} /></Grid> :
                    pqStatusGruppe.length == 0 ? <Typography variant="h6">Keine Gruppen vorhanden. <Link onClick={() => history.push("/uebersicht/gruppenverwaltung")} style={{ cursor: "pointer" }}>Zur Gruppenverwaltungsseite</Link></Typography> : gruppentypen.map(gruppentyp => (
                        <Grid item md={12} key={gruppentyp} className={classes.paddingPaper}>
                            <Paper>
                            <Grid item container md={12}>
                                <Accordion style={{width: "100%", marginBottom:"-3px"}}>
                                <AccordionSummary >
                                    <Typography className={classes.tableHeadline} variant="h6" style={{marginBottom:"8px"}} >{gruppentyp}</Typography>
                                </AccordionSummary>
                                </Accordion>
                            </Grid>
                            <TableContainer className={classes.heightScrolledTableBottom}>
                                <Table stickyHeader style={{overflow:"hidden"}}>
                                    <TableHead>
                                        <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor:"white", fontWeight:"600" }} width="20%"></TableCell>
                                        <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor:"white", fontWeight:"600" }} align="center">letzte 24 Stunden</TableCell>
                                        <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor:"white", fontWeight:"600" }} align="center">letzte 30 Tage</TableCell>
                                        <TableCell className={classes.tableHeadlineSub} style={{ backgroundColor:"white", fontWeight:"600" }} align="center">letzte 12 Monate</TableCell>
                                    </TableHead>
                                    <TableBody>
                                        {pqStatusGruppe.filter(x => x.gruppentyp == gruppentyp).sort((a, b) => a.gruppenname.localeCompare(b.gruppenname)).map((statusElement) => (
                                            <TableRow key={statusElement.gruppenname} hover={true}>
                                                <TableCell>{statusElement.gruppenname}</TableCell>
                                                <TableCell align="center" onClick={() => linkToDetails(statusElement.gruppenId, "24h")} style={{ cursor: "pointer" }}>{getIconForStateValue(statusElement.status24h)}</TableCell>
                                                <TableCell align="center" onClick={() => linkToDetails(statusElement.gruppenId, "1M")} style={{ cursor: "pointer" }}>{getIconForStateValue(statusElement.status1Month)}</TableCell>
                                                <TableCell align="center" onClick={() => linkToDetails(statusElement.gruppenId, "12M")} style={{ cursor: "pointer" }}>{getIconForStateValue(statusElement.status12Month)}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            </Paper>
                        </Grid>
                    ))}
            </Grid>
        </Container>
    )
}
